import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "./Styles.css";
import {
  Download,
  Thumbnails,
  Counter,
  Fullscreen,
  Slideshow,
} from "yet-another-react-lightbox/plugins";
import { useNavigate } from "react-router-dom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";
import useFetchData from "../../API/useFetchData.js";
import useFetchMedia from "../../API/useGetMedia.js";
import { usePhotos } from "../../Redux/PhotosContext.js";

const ImageView = () => {
  const { photos, setPhotos, Entered, setIsEntered } = usePhotos();

  const [index, setindexState] = useState(localStorage.getItem("index") || 0);
  const setindex = (index) => {
    setindexState(index);
    localStorage.setItem("index", index);
  };
  const [open, setOpen] = useState(true);
  const { fetchData: fetcthPhotos } = useFetchData("/manager/photos");
  const { fetchMedia } = useFetchMedia();
  const navigate = useNavigate();
  useEffect(() => {
    if (!Entered) {
      const loadPhotos = async () => {
        try {
          const response = await fetcthPhotos({ approved: "true" });
          // Set initial photo data (without URLs)
          const initialPhotos = response.map((photo) => ({
            id: photo.id,
            url: null, // Placeholder for the actual media URL
            uploadedBy: photo.uploadedBy,
            approved: photo.approved,
            createdAt: photo.createdAt,
            updatedAt: photo.updatedAt,
            className: photo.className,
            yearName: photo.yearName,
          }));
          setPhotos(initialPhotos);

          const imageMap = {};
          const processImage = async (i) => {
            const photo = response[i];
            const media = await fetchMedia(photo.photoUrl);
            setPhotos((prevPhotos) =>
              prevPhotos.map((p) =>
                p.id === photo.id ? { ...p, url: media } : p
              )
            );
            imageMap[photo.id] = media.url;
          };
          // Fetch media URLs one by one and update the photos state
          let cont = false;
          if (index < response.length) {
            // start with the current index
            await processImage(index);
            cont = true;
          } else {
            setindex(0);
          }
          for (let i = 0; i < response.length; i++) {
            if (i === index && cont) continue;
            await processImage(i);
          }
        } catch (error) {
          console.error("Error fetching photos:", error);
        }

        setIsEntered(true);
      };

      loadPhotos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSlideChange = (index) => {
    setindex(index.index);
  };

  const galleryPhotos = photos.map((photo) => ({
    id: photo.id,
    src: photo.url ? photo.url.url : "",
  }));

  return (
    <>
      {open && (
        <Lightbox
          open={open}
          close={() => {
            setOpen(false);
            navigate("/Accepted");
          }}
          styles={{
            overlay: { pointerEvents: "auto" },
          }}
          slides={galleryPhotos}
          carousel={{ preload: 5 }}
          index={index}
          thumbnails={{
            imageFit: "cover",
          }}
          toolbar={{
            buttons: ["close"],
          }}
          plugins={[Download, Thumbnails, Counter, Fullscreen, Slideshow]}
          on={{
            view: handleSlideChange,
          }}
        />
      )}
    </>
  );
};

export default ImageView;
